import { Component, OnChanges, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AceitesService } from '../../../services/saude/aceites.service';
// import { ProvaVidaType } from 'src/app/shared/enum/prova-vida-type';
import { faCamera, faEye, faSquareXmark, faUpload } from '@fortawesome/free-solid-svg-icons';
import { ModalFotoComponent } from 'src/app/shared/modals/modal-foto/modal-foto.component';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-prova-vida',
  templateUrl: './prova-vida.component.html',
  styleUrls: ['./prova-vida.component.css']
})
export class ProvaVidaComponent implements OnChanges {
  videoRef: any;
  //Icones
  faUpload = faUpload;
  faCamera = faCamera;
  faSquareXmark = faSquareXmark;
  faEye = faEye;
  // provaVidaTypes = ProvaVidaType;
  documentTypes: any = DocumentType;
  excededMaxFileSize: boolean = false;
  loading: boolean = false;
  dataProvaVida: any;
  provaVida: any;
  video = document.querySelector('#video');
  contador: number = 1;
  todaysDate: any = new Date().toJSON().split('T')[0];
  listToSend: any[] = [];
  filesList64: any[] = [];
  tipoProvaVida: any[] = [
    {
      nome: 'Prova de Vida Fundação Copel',
      id: 1
    },
    {
      nome: 'Prova de Vida realizada no INSS',
      id: 2
    }
  ];
  formData: FormGroup = new FormGroup({
    documentoPessoaFisicaFiles: this.createOtherFile(false),
    selfie: this.createOtherFile(false),
    provaVidaInssFiles: this.createOtherFile(false),
    provaVidaId: new FormControl(null, [Validators.required]),
    requestDate: new FormControl(null, [Validators.required])
  });
  constructor(private formBuilder: FormBuilder, private modalService: NgbModal, private aceitesService: AceitesService) { }
  createOtherFile(enabled: boolean) {
    return new FormGroup({
      name: new FormControl({ value: 'otherFiles', disabled: !enabled }),
      files: new FormControl({ value: null, disabled: !enabled }),
    })
  }
  addDocumentosPessoais(event?: any) {
    this.formData.get(`documentoPessoaFisicaFiles.files`)?.setValue(event);
    this.formData.get(`documentoPessoaFisicaFiles`)?.updateValueAndValidity();
  }
  addSelfie(event?: any) {
    this.formData.get(`selfie.files`)?.setValue(event);
    this.formData.get(`selfie`)?.updateValueAndValidity();
  }
  addDocInss(event?: any) {
    this.formData.get(`provaVidaInssFiles.files`)?.setValue(event);
    this.formData.get(`provaVidaInssFiles`)?.updateValueAndValidity();
  }
  addPhoto(fileType: any, file: any): any {
    this.filesList64.push(file);
    const maxSize = 1048576 * 25;
    let actualSize = 0;
    let olderSize = 0;
    let formFiles = this.formData.get(`${fileType}.files`)?.value;
    if (formFiles) {
      formFiles.forEach((a: any) => {
        olderSize += a.size * 1024
        let duplicatedFileIndex = this.filesList64.findIndex((newfile: any) => newfile.fileName === a.fileName && newfile.size === a.size);
        if (duplicatedFileIndex > -1) {
          actualSize -= (this.filesList64[duplicatedFileIndex].size * 1024)
          this.filesList64.splice(duplicatedFileIndex, 1);
        }
      });
      formFiles = formFiles.concat(this.filesList64);
    } else {
      formFiles = this.filesList64;
    }
    this.formData.get(`${fileType}.files`)?.setValue(formFiles);
    this.formData.get(`${fileType}`)?.updateValueAndValidity();
    if ((actualSize + olderSize) > maxSize) { this.excededMaxFileSize = true; return false; }
  }
  removeFile(fileType: string, index: number) {
    let actualSize = 0
    const maxSize = 1048576 * 25;
    let files = this.formData.get(`${fileType}.files`)?.value;
    files.splice(index, 1);
    this.formData.get(`${fileType}.files`)?.patchValue(files)
    files.forEach((f: any) => actualSize += (f.size * 1024)
    );
    if (actualSize > maxSize) {
      this.excededMaxFileSize = true;
      return false;
    }
    this.excededMaxFileSize = false;
    return true;
  }
  lifeTestChanged(event: any) {
    //Limpando os arquivos toda vez que for selecionado um novo tipo
    this.clearAllFiles();
    if (event === undefined || event === null || event.id === 0) {
      this.formData.get("provaVidaId")?.setValue(null);
    } else if (event.id == 1) {
      //FCopel
      return this.formData.get("provaVidaId")?.setValue(1);
    } else if (event.id == 2) {
      //INSS
      return this.formData.get("provaVidaId")?.setValue(2);
    }
  }
  clearAllFiles() {
    this.formData.get('documentoPessoaFisicaFiles')?.reset();
    this.formData.get('selfie')?.reset();
    this.formData.get('provaVidaInssFiles')?.reset();
  }
  inputSelecionado(tipo: string) { }
  takePhoto(type: any) {
    this.modalService.open(ModalFotoComponent, { windowClass: 'camera-modal-size', centered: true }).result.then(
      (resultModal: any) => {
        if (resultModal !== null) {
          resultModal.fileName = "documento-" + this.contador + ".PNG";
          this.addPhoto(type, resultModal);
          this.contador++;
        }
      }
    );
    //modalRef.componentInstance.contribution = this.contributionHistory;
  }
  solicitaProvaVida(type: string) {
    this.listToSend = [];
    //chamada da API
    if (type === 'Fundacao') {
      let concatenarLista = [...this.formData.get('selfie.files')?.value, ...this.formData.get('documentoPessoaFisicaFiles.files')?.value];
      concatenarLista.forEach((x: any) =>
        this.listToSend.push({
          contentType: x.contentType,
          file: x.file,
          fileName: x.fileName
        }));
      this.aceitesService.PostProvaVida({ Files: this.listToSend, tipoProva: 'FCopel' }).subscribe(() => {
        Swal.fire({
          title: 'Perfeito, sua Prova de Vida foi concluída!',
          text: 'Caso seja identificada alguma inconsistência você será contatado. Lembrando que não é necessário enviar nenhum documento para a Fundação Copel durante o ano de 2022.',
          icon: 'success',
          showConfirmButton: false
        }).then((result: any) => {
          this.lifeTestChanged(null);
          window.location.reload();
        });
      });
    } else {
      this.formData.get('provaVidaInssFiles.files')?.value.forEach((x: any) => this.listToSend.push({
        contentType: x.contentType,
        file: x.file,
        fileName: x.fileName
      }));
      this.aceitesService.PostProvaVida({ Files: this.listToSend, TipoProva: 'INSS' }).subscribe(() => {
        Swal.fire({
          title: 'Perfeito, sua Prova de Vida foi concluída!',
          text: 'Caso seja identificada alguma inconsistência você será contatado. Lembrando que não é necessário enviar nenhum documento para a Fundação Copel durante o ano de 2022.',
          icon: 'success',
          showConfirmButton: false
        }).then((result: any) => {
          this.lifeTestChanged(null);
          window.location.reload();
        });
      });
    }
  }
  provaVidaValidacao() {
    if (this.provaVida) {
      Swal.fire({
        title: 'Prova de vida ainda não foi realizada este ano!',
        text: 'Por gentileza realize a prova de vida via através da opção "Prova de Vida na coluna x" ou através do link abaixo.',
        icon: 'error',
        showConfirmButton: true,
        showCancelButton: true,
        cancelButtonText: 'Fechar!',
        confirmButtonText: 'Realizar já!',
        footer: `
        <a href="https://api.whatsapp.com/send?phone=554199103-8616&text=@vocenocontrole" style="position: relative;" class="float "target="_blank">
          Entre em contato via Whatsapp!
        </a>
        `
      }).then((result: any) => {
        if (result.value) {
          //Primeiro Retorno
        } else if (result.dismiss) {
          //Segundo Retorno
        }
      })
    }
  }
  ngOnChanges(changes: SimpleChanges): void { }
}
const toBase64 = (file: any) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => resolve(reader.result);
  reader.onerror = error => reject(error);
});
const toByteArray = (file: any) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsArrayBuffer(file);
  reader.onload = () => resolve(new Uint8Array(reader.result as ArrayBuffer));
  reader.onerror = error => reject(error);
});
